import { render } from "./SecondInfoPage.vue?vue&type=template&id=ed0cf1cc&scoped=true"
import script from "./SecondInfoPage.vue?vue&type=script&lang=js"
export * from "./SecondInfoPage.vue?vue&type=script&lang=js"

import "./SecondInfoPage.vue?vue&type=style&index=0&id=ed0cf1cc&lang=scss&scoped=true"

import exportComponent from "/home/forge/vienaiespeja.on-forge.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed0cf1cc"]])

export default __exports__